import 'react-slideshow-image/dist/styles.css';
import '../../sass/dashboard.scss';
import { Slide } from "react-slideshow-image";
import PostBrief from "../common/post-brief";
import { getTopTrending } from "../../utils/post-utils";
import useWindowDimensions from "../../utils/hooks/windowDimensions";
import { useEffect, useState } from "react";
import { Post } from "../../common/types/post.types";
import Loading from "../common/loading";

function TopTrending() {
  const [posts, setPosts] = useState<Post[]>([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true);
    getTopTrending().then(data => {
      setPosts(data);
      setLoading(false);
    })
  }, []);

  const {width} = useWindowDimensions();

  const contents: any = posts?.map((post) => {
    return <PostBrief key={post.id} post={post} currentSectionTree={[]}/>
  })

  return (
    <div className={'top-trending'}>
      <h1 className={'section-name'}>Top trending<div className={'decorator'}></div></h1>
      {loading ?
        <Loading h={200}/> :
        (
          <div style={{display: contents?.length === 0 ? 'none' : ''}}>
            <Slide slidesToScroll={1} slidesToShow={width < 480 ? 1 : width < 900 ? 2 : 3} indicators={true} autoplay={false} transitionDuration={500}>
              {contents}
            </Slide>
          </div>
        )
      }
    </div>
  )
}

export default TopTrending;
